export const BASE_CONHECIMENTO_ATUALIZAR_PAGE = 'BASE_CONHECIMENTO_ATUALIZAR_PAGE';
export const page = (page) => ({
  type: BASE_CONHECIMENTO_ATUALIZAR_PAGE,
  payload: {
    page,
  },
});
export const BASE_CONHECIMENTO_ATUALIZAR_FILTRO = 'BASE_CONHECIMENTO_ATUALIZAR_FILTRO';
export const filter = (filter) => ({
  type: BASE_CONHECIMENTO_ATUALIZAR_FILTRO,
  payload: {
    filter,
  },
});



// WEBPACK FOOTER //
// ./src/containers/BaseConhecimento/store/base.action.js